/**
 * HomeFooter — Footer-ka Bogga Hore
 *
 * Footer leh brand, social media icons, links, iyo copyright
 * Data-giisa wuxuu ku jiraa: data/footerData.js
 *
 * Waxaad ka bedeli kartaa:
 *  - Links-ka alaabta iyo shirkadda (data/footerData.js)
 *  - WhatsApp number-ka (data/footerData.js)
 *  - Social media links-ka (line 22-60)
 *  - Brand description-ka (line 78-81)
 *  - Copyright text-ka (line 135)
 */
import { Separator } from "../../components/ui/separator";

/* ── Data — links iyo contact info ── */
import { productLinks, WHATSAPP_URL, PHONE_DISPLAY } from "./data/footerData";

/* ── Social Media Icons ── */
const socials = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61587494656459",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    name: "WhatsApp",
    href: "https://wa.me/252619150114",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
      </svg>
    ),
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/ganacsihub1?igsh=cmU1aGFhNWJuOHE3",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
      </svg>
    ),
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@ganacsihub1?_r=1&_t=ZS-94Xv8XCc54C",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.46V13.2a8.16 8.16 0 005.58 2.17v-3.44a4.85 4.85 0 01-3.77-1.47V6.69h3.77z" />
      </svg>
    ),
  },
];

export default function HomeFooter() {
  return (
    <footer className="border-t border-border font-heading">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">

        {/* ── Top: Brand + Links ── */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">

          {/* Brand section — logo + description + social icons */}
          <div className="lg:col-span-5">
            {/* Logo */}
            <div className="flex items-center gap-2 mb-4">
              <img
                src={`${process.env.PUBLIC_URL}/images/logos/logo-mark.png`}
                alt="GanacsiHub"
                className="rounded-xl object-cover"
                style={{ height: 44, width: 44 }}
              />
              <span
                className="text-2xl font-bold font-heading"
                style={{ letterSpacing: "-0.03em" }}
              >
                <span className="text-navy">Ganacsi</span>
                <span className="text-teal">Hub</span>
              </span>
            </div>

            {/* Description */}
            <p className="text-sm text-muted leading-relaxed max-w-sm mb-6 font-medium">
              Shirkad ICT ah oo Soomaaliyeed. Waxaan ganacsiyada u dhisnaa app,
              website iyo nidaam lacag-bixin oo u gaar ah — naqshad, horumarin
              iyo taageero joogto ah.
            </p>

            {/* Social media icons */}
            <div className="flex items-center gap-3">
              {socials.map((s) => (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  className="flex h-9 w-9 items-center justify-center rounded-lg border border-border bg-card text-muted hover:text-navy hover:border-navy/20 transition-colors"
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* ── Links columns ── */}
          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {/* Product links */}
            <div>
              <h4 className="text-sm font-bold text-navy mb-4 font-heading">Alaabta</h4>
              <ul className="space-y-2.5">
                {productLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-muted font-medium hover:text-navy transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact info */}
            <div>
              <h4 className="text-sm font-bold text-navy mb-4 font-heading">Xiriirka</h4>
              <ul className="space-y-2.5">
                <li>
                  <a
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-muted font-medium hover:text-navy transition-colors"
                  >
                    WhatsApp
                  </a>
                </li>
                <li>
                  <a
                    href={`tel:${PHONE_DISPLAY.replace(/\s/g, "")}`}
                    className="text-sm text-muted font-medium hover:text-navy transition-colors"
                  >
                    {PHONE_DISPLAY}
                  </a>
                </li>
                <li className="pt-2">
                  <a
                    href="https://maps.google.com/?q=Somnet+Tower+Mogadishu+Somalia"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group flex items-start gap-2.5 text-sm text-muted font-medium hover:text-navy transition-colors"
                  >
                    <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg border border-border bg-card group-hover:border-navy/20 group-hover:text-navy transition-colors">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                        <circle cx="12" cy="10" r="3" />
                      </svg>
                    </span>
                    <span className="leading-relaxed">
                      7th Floor, Somnet Tower,<br />
                      Mogadishu, Somalia
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <Separator className="my-10" />

        {/* ── Bottom bar — copyright + legal links ── */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted font-medium">
            &copy; 2026 GanacsiHub. Dhammaan xuquuqda way xifdiyaan.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-muted font-medium hover:text-navy transition-colors">
              Shuruudaha
            </a>
            <a href="#" className="text-xs text-muted font-medium hover:text-navy transition-colors">
              Asturnaanta
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
